module.exports = new __parcel__URL__("desc_1.beb8e98c.png").toString();